module.exports = __webpack_public_path__ + "img/garageservices2.dc3ded69.jpg";